import React from "react";
import "./layout.css";

import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";

const Layout = ({ children }) => {
    return (
        <div className="app__layout">
            <Navbar />
            <main className="app__layout-main">
                { children }
            </main>
            <Footer />
        </div>
    )
}

export default Layout;